export const messages = {
  en: {
    storeInfoManage: {
      basicInfo: 'Basic Information',
      storeName: 'Store Name',
      storeAddress: 'Store Address',
      contactNumber: 'Contact Number',
      storeType: 'Store Type',
      legalPerson: 'Legal Person',
      nearbyLandmark: 'Nearby Landmark',
      operation: 'Operation',
      edit: 'Edit',
      storeInfo: 'Store Information',
      attributeName: 'Attribute Name',
      attributeValue: 'Attribute Value',
      fetchError: 'Failed to fetch store information'
    },
    editStoreInfo: {
      title: 'Edit Store Information',
      storeName: 'Store Name',
      storeNamePlaceholder: 'Store name cannot be modified',
      storeAddress: 'Store Address',
      storeAddressPlaceholder: 'Required, please enter store address',
      contactNumber: 'Contact Number',
      contactNumberPlaceholder: 'Required, please enter contact number',
      nearbyLandmark: 'Nearby Landmark',
      nearbyLandmarkPlaceholder: 'Required, please enter nearby landmark',
      mapX: 'Map X Coordinate',
      mapXPlaceholder: 'Optional, please enter X coordinate',
      mapY: 'Map Y Coordinate',
      mapYPlaceholder: 'Optional, please enter Y coordinate',
      validate: {
        nameRequired: 'Store name is required',
        nameMaxLength: 'Store name cannot exceed 100 characters',
        addressRequired: 'Store address is required',
        addressMaxLength: 'Store address cannot exceed 200 characters',
        telRequired: 'Contact number is required',
        telMaxLength: 'Contact number cannot exceed 11 digits',
        landmarkRequired: 'Nearby landmark is required',
        landmarkMaxLength: 'Nearby landmark cannot exceed 200 characters'
      }
    },
    editStoreAttr: {
      title: 'Edit Store Attribute',
      attributePlaceholder: 'Store attribute is required',
      validate: {
        valueRequired: 'Attribute value is required',
        valueMaxLength: 'Attribute value cannot exceed 50 characters',
        attrIdRequired: 'Attribute ID cannot be empty'
      }
    }
  },
  zh: {
    storeInfoManage: {
      basicInfo: '基本信息',
      storeName: '商户名称',
      storeAddress: '商户地址',
      contactNumber: '联系电话',
      storeType: '商户类型',
      legalPerson: '企业法人',
      nearbyLandmark: '附近地标',
      operation: '操作',
      edit: '修改',
      storeInfo: '商户信息',
      attributeName: '属性名称',
      attributeValue: '属性值',
      fetchError: '获取商户信息失败'
    },
    editStoreInfo: {
      title: '修改商户信息',
      storeName: '商户名称',
      storeNamePlaceholder: '商户名称不能修改',
      storeAddress: '商户地址',
      storeAddressPlaceholder: '必填，请填写商户地址',
      contactNumber: '电话',
      contactNumberPlaceholder: '必填，请填写联系电话',
      nearbyLandmark: '附近地标',
      nearbyLandmarkPlaceholder: '必填，请填写附近地标',
      mapX: '地区X坐标',
      mapXPlaceholder: '选填，请填写x坐标',
      mapY: '地区Y坐标',
      mapYPlaceholder: '选填，请填写y坐标',
      validate: {
        nameRequired: '商户名称必填',
        nameMaxLength: '商户名称不能超过100位',
        addressRequired: '商户地址必填',
        addressMaxLength: '商户地址不能超过200位',
        telRequired: '联系电话必填',
        telMaxLength: '联系电话最多11位',
        landmarkRequired: '附件地标必填',
        landmarkMaxLength: '附件地标位置最多200位'
      }
    },
    editStoreAttr: {
      title: '修改商户属性',
      attributePlaceholder: '商户属性必填',
      validate: {
        valueRequired: '必填',
        valueMaxLength: '属性值不能超过50位',
attrIdRequired: '属性id不能为空'
      }
    }
  },
  'zh-TW': {
    storeInfoManage: {
      basicInfo: '基本資訊',
      storeName: '商戶名稱',
      storeAddress: '商戶地址',
      contactNumber: '聯繫電話',
      storeType: '商戶類型',
      legalPerson: '企業法人',
      nearbyLandmark: '附近地標',
      operation: '操作',
      edit: '修改',
      storeInfo: '商戶資訊',
      attributeName: '屬性名稱',
      attributeValue: '屬性值',
      fetchError: '獲取商戶資訊失敗'
    },
    editStoreInfo: {
      title: '修改商戶資訊',
      storeName: '商戶名稱',
      storeNamePlaceholder: '商戶名稱不能修改',
      storeAddress: '商戶地址',
      storeAddressPlaceholder: '必填，請填寫商戶地址',
      contactNumber: '電話',
      contactNumberPlaceholder: '必填，請填寫聯繫電話',
      nearbyLandmark: '附近地標',
      nearbyLandmarkPlaceholder: '必填，請填寫附近地標',
      mapX: '地區X座標',
      mapXPlaceholder: '選填，請填寫x座標',
      mapY: '地區Y座標',
      mapYPlaceholder: '選填，請填寫y座標',
      validate: {
        nameRequired: '商戶名稱必填',
        nameMaxLength: '商戶名稱不能超過100位',
        addressRequired: '商戶地址必填',
        addressMaxLength: '商戶地址不能超過200位',
        telRequired: '聯繫電話必填',
        telMaxLength: '聯繫電話最多11位',
        landmarkRequired: '附件地標必填',
        landmarkMaxLength: '附件地標位置最多200位'
      }
    },
    editStoreAttr: {
      title: '修改商戶屬性',
      attributePlaceholder: '商戶屬性必填',
      validate: {
        valueRequired: '必填',
        valueMaxLength: '屬性值不能超過50位',
        attrIdRequired: '屬性id不能為空'
      }
    }
  }
}